import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Datatable from '../../../ExtraComponents/ReusableTable2';
import { getCommonTemplet, deleteCommonTemplet } from "../../../ReduxStore/Slice/Templets/QuotesTemplets";
import { useDispatch } from "react-redux";
import { PenLine, Trash2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom';
import sweatalert from "sweetalert2";
import ReactPaginate from "react-paginate";


const AllQuotes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [commonTempletData, setCommonTempletData] = useState([]);

  const [InputValue, setInputValue] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);



  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])



  useEffect(() => {
    CommonTemplet();
  }, [currentPage, pageSize, InputValue]);


  const CommonTemplet = async () => {
    const req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue }
    await dispatch(getCommonTemplet(req)).unwrap()
      .then((res) => {
        if (res.status) {
          setCommonTempletData(res.data)
          setTotalRecords(res?.pagination?.total)

        }
        else {
          setCommonTempletData([])

        }
      })
      .catch((err) => {
        console.log("Error ", err)
      })

  }



  const columns = [
    {
      name: "Template Name",
      cell: (row) => (
        <a
          href={`#/admin/template/view-common-template?id=${row.id}`}
          className="text-pink font-bold"
          style={{ fontWeight: "bold" }}
          onClick={(e) => {
            if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
              e.preventDefault();
              navigate("/admin/template/view-common-template", {
                state: { row },
              });
            }
          }}
        >
          {row.name}
        </a>
      ),
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => <>
        <PenLine onClick={() => handleEdit(row)} />
        {
          ['PARTIAL_LOGO', 'PARTIAL_CONTRACT_HEADER', 'PARTIAL_CONTRACT_FOOTER'].includes(row?.name) ?
            "" :
            <Trash2
              onClick={() => handleDelete(row)}
            />
        }

      </>,
      sortable: true,
    },

  ];

  const handleEdit = (row) => {
    navigate(`/admin/template/edit-common-template`, { state: row })
  };



  const handleDelete = async (row) => {

    sweatalert.fire({
      title: "Are you sure?",
      text: "You want to delete this common template! ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id }
        await dispatch(deleteCommonTemplet(req)).unwrap()
          .then((response) => {
            if (response.status) {
              sweatalert.fire({
                title: "Success",
                text: "common template Deleted Successfully",
                icon: "success",
                timer: 3000,
                timerProgressBar: true
              }
              );
              CommonTemplet()
            }
          })
          .catch((error) => {
            console.error("Error deleting package:", error);
          });
      } else if (result.dismiss === sweatalert.DismissReason.cancel) {
        return
      }
    });
  }


  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/quote/quotes-dashboard">
              <i className='bx bx-arrow-back text-pink'></i>
            </Link> All Common Templates
          </h4>
        </div>
        <div className="col-auto align-self-center">
          <Link to="/admin/template/add-common-template" className="btn btn-pink" id="Dash_Date">
            <span className="ay-name" id="Day_Name">Add New Template</span>
          </Link>
        </div>
      </div>

      <section className="section dashboard">
        <div className="row mb-3">
          <data className='col-lg-3 datatable-search'>
            <input type="text"
              className='search p-2 icon'
              placeholder='Search here'
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}

            />
          </data>

        </div>
        <div className="table-main-div">

          <Datatable
            columns={columns}
            data={commonTempletData}
            filter={false}
          />
          {commonTempletData.length > 0 ? <div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />

            <div className="mt-0">

              <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={0}>{"ALL"}</option>


              </select>
            </div>
          </div> : ""}
        </div>
      </section>
    </div>
  );
};

export default AllQuotes;
